import Fullscreen from './Fullscreen'

export default Fullscreen
// eslint-disable-next-line import/export
export * from './Fullscreen'
